import React, { useContext, useEffect, useState } from 'react';
import { axiosSecureInstance } from '../../api/axios';
import { useNavigate } from 'react-router-dom';
import { PromptTemplateContext } from '../../contexts/PromptTemplateContext';
import { Modal, Spin } from 'antd';
import { ALL_USER_GET_PROMPT_TEMPLATES_SLUG } from '../../constants/Api_constants';
import { ThemeContext } from '../../contexts/themeConfig';

const Templates = () => {
  const { updateCurrentPromptTemplate } = useContext(PromptTemplateContext);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(true);
  const lowerCaseSearch = searchTerm.toLowerCase();
  const [loading, setLoading] = useState(false);
  const { theme } = useContext(ThemeContext);


  const handleChooseTemplate = (description) => {
    updateCurrentPromptTemplate(description);
    toggleModal();
  };


  const toggleModal = () => {
    if (window.location.pathname === "/chat") {
      setShowModal(!showModal);
    } else {
      navigate("/chat");
      setShowModal(!showModal);
    }
  };

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        setLoading(true)
        const response = await axiosSecureInstance.get(ALL_USER_GET_PROMPT_TEMPLATES_SLUG());
        const result = response?.data?.templates;
        console.log("Templates:", result);
        setTemplates(result);
        setLoading(false)
      } catch (error) {
        console.log(error);
        setLoading(false)
      } finally {
        setLoading(false)
      }
    };
    fetchTemplates();
  }, []);


  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    navigate("/chat");
  };

  return (
    <div className=''>

      <Modal
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        centered
        width={700}
      >

        <div className=''>
          <div class="input-group justify-content-center">
            <div class="form-outline w-75 mb-5">
              <input
                type="search"
                id="form1"
                class="form-control "
                placeholder="Search here ..."
                style={{ border: "1px solid grey" }}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />

            </div>
          </div>

        </div>
        {
          loading ? <div className='templates-loading-container'><Spin /></div>
            :
            <div className='template-content-container'>

              <div>
                {templates.length ? <>
                {
                   templates?.map((item) => (
                    <div key={item._id}>
  
                      <ul style={{ padding: "none" }}>
                        {item?.templates
                          ?.filter((template) => {
                            return template.title
                              .toLowerCase()
                              .includes(lowerCaseSearch)
                              ||
                              template.description
                                .toLowerCase()
                                .includes(lowerCaseSearch)
                          })
                          ?.map((template) => (
                            <div
                            key={template._id}
                            className="template-item"
                            onClick={() =>
                              handleChooseTemplate(template.description)
                            }
                            style={{
                              cursor: "pointer",
                              padding: "12px 16px",
                              borderRadius: "8px",
                              marginBottom: "8px",
                              transition: "background-color 0.2s ease",
                              backgroundColor: theme === "dark" ? "#333" : "#f9f9f9",
                              color: theme === "dark" ? "#fff" : "#333",
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                theme === "dark" ? "#555" : "#E3E3E3")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                theme === "dark" ? "#333" : "#f9f9f9")
                            }
                          >
                            <p style={{ margin: 0, fontWeight:"500", fontSize:"18px" }}>{template.title}</p>
                          </div>
                          ))}
                      </ul>
                    </div>
                  ))
                }
                </> : null}
              </div>
            </div>
        }

      </Modal>


    </div>
  );
};

export default Templates;